/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in popup MST_050
 * @created at      :   2026/01/21
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    company_cd: '',
    station_cd: '',
    station_name: '',
    pageSize: 10,
    pageNo: 1
};

export default {
    namespaced: true,
    state: {
        listData: [],
        data: { ...dataInit },
        msgNoData: '該当するデータが存在しません',
        totalRows: 0
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setTotalRows(state, data) {
            state.page_no = data.page ?? [];
            state.page_size = data.pagesize ?? [];
            state.totalRows = data.total_rows;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        setMessage(state, data) {
            state.msgNoData = data;
        }
    },
    actions: {
        searchStationInfo(context, param) {
            try {
                const stationCd = param.station_cd ? Number(param.station_cd) : 0;
                const companyCd = param.company_cd ? Number(param.company_cd) : 0;
                const searchParam = {
                    company_cd_from: companyCd || 0,
                    company_cd_to: companyCd || 0,
                    station_cd_from: stationCd || 0,
                    station_cd_to: stationCd || 0,
                    station_name: param.station_name ?? '',
                    prefecture_cd: 0,
                    department_cd_from: 0,
                    department_cd_to: 0,
                    pageNo: param.pageNo ?? 1,
                    pageSize: param.pageSize ?? 10,
                    col: '',
                    sort: ''
                };
                repository.searchStationInfo(searchParam).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const listData = data.Data?.result ?? [];
                        if (listData.length > 0) {
                            context.commit('setListData', listData);
                        } else {
                            context.commit('setListData', []);
                            context.commit('setMessage', '該当するデータが存在しません');
                        }
                        if (param.callback) {
                            param.callback(data);
                        }
                        const paging = data.Data?.paging?.[0] ?? { total_rows: 0, page: 1, pagesize: searchParam.pageSize };
                        context.commit('setTotalRows', paging);
                    }
                });
            } catch (e) {
                console.log('searchStationInfo: ' + e.message);
            }
        }
    }
};
